"use client";

import { ConfigProvider } from "antd";
import type { ReactNode } from "react";

// antd applies its own default font-family (the system font stack) to its
// components, which overrides the inherited site font (Ping L) on anything
// wrapped in antd primitives — most visibly the homepage/landing slider
// (antd <Flex>). Point antd's global token at the Ping L CSS variable so every
// antd component uses the site font. The font is self-hosted via next/font
// (see fonts.ts) and exposed as --font-ping-l on <html>; the generated family
// name is hashed, so we must reference the variable rather than a literal name.
export default function AntdThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider theme={{ token: { fontFamily: "var(--font-ping-l), sans-serif" } }}>
      {children}
    </ConfigProvider>
  );
}
